import React,{useState} from 'react'

import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";

import thumb17 from '../images/thumb_17.jpg';
import thumb18 from '../images/thumb_18.jpg';
import thumb19 from '../images/thumb_19.jpg';

import img17 from '../images/17.png';
import img18 from '../images/18.png';
import img19 from '../images/19.png';

import "./modal.css";

export default function Cataract(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img17);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }

    const cards = [
        { title: "Cataract - Cortical", thumb: thumb17, image: img17 },
        { title: "Cataract - Cortical", thumb: thumb18, image: img18 },
        { title: "Cataract - Posterior Capsular", thumb: thumb19, image: img19 },
    ]
    return(
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Cataract</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}

                    </div>
                </div>
            </div>
            {/* Reusable modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}